import { paymentStatementApi } from './base';

// ROC-96: replies to the sender of a bounced statement, reviewed before they are sent.
export interface ReplyDraft {
	id: string;
	statement_file_id: string;
	status: 'pending' | 'sending' | 'sent' | 'send_unknown' | 'discarded';
	to_email: string | null;
	subject: string;
	body: string;
	conversation_id: string | null;
	approved_by: string | null;
	created_at: string;
	updated_at: string;
	sent_at: string | null;
}

export interface ReplyDraftChanges {
	to_email?: string;
	subject?: string;
	body?: string;
}

const replyDraftsApi = paymentStatementApi
	.enhanceEndpoints({ addTagTypes: ['ReplyDrafts'] })
	.injectEndpoints({
		endpoints: (builder) => ({
			getReplyDrafts: builder.query<{ drafts: ReplyDraft[] }, string>({
				query: (fileId) => `/statement/files/${fileId}/reply-drafts`,
				providesTags: ['ReplyDrafts'],
			}),
			createReplyDraft: builder.mutation<ReplyDraft, string>({
				query: (fileId) => ({
					url: `/statement/files/${fileId}/reply-drafts`,
					method: 'POST',
					body: {},
				}),
				invalidatesTags: ['ReplyDrafts'],
			}),
			updateReplyDraft: builder.mutation<
				ReplyDraft,
				{ id: string; changes: ReplyDraftChanges }
			>({
				query: ({ id, changes }) => ({
					url: `/statement/reply-drafts/${id}`,
					method: 'PATCH',
					body: changes,
				}),
				invalidatesTags: ['ReplyDrafts'],
			}),
			approveReplyDraft: builder.mutation<ReplyDraft, string>({
				query: (id) => ({
					url: `/statement/reply-drafts/${id}/approval`,
					method: 'POST',
				}),
				invalidatesTags: ['ReplyDrafts'],
			}),
			discardReplyDraft: builder.mutation<void, string>({
				query: (id) => ({
					url: `/statement/reply-drafts/${id}`,
					method: 'DELETE',
				}),
				invalidatesTags: ['ReplyDrafts'],
			}),
		}),
	});

export const {
	useGetReplyDraftsQuery,
	useCreateReplyDraftMutation,
	useUpdateReplyDraftMutation,
	useApproveReplyDraftMutation,
	useDiscardReplyDraftMutation,
} = replyDraftsApi;
